var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

module.exports = function (e) {
  var t = {};

  function o(n) {
    if (t[n]) return t[n].exports;
    var r = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
  }

  return o.m = e, o.c = t, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      o.d(n, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 63);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  5: function _(e, t) {
    e.exports = require("../Icon/Icon");
  },
  63: function _(e, t, o) {
    "use strict";

    var n = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var o in e) {
        Object.hasOwnProperty.call(e, o) && (t[o] = e[o]);
      }
      return t.default = e, t;
    },
        r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(o(1)),
        l = n(o(2)),
        a = r(o(64)),
        d = r(o(8)),
        s = o(3),
        u = r(o(5)),
        c = s.colorPalettes.KineduPalette,
        f = l.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.7);\n  background: ", ";\n  z-index: 10000;\n  opacity: 0;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n\n  transition: opacity 0.3s ease-out;\n\n  ", "\n"])), function (_ref) {
      var e = _ref.overlayColor;
      return e;
    }, function (_ref2) {
      var e = _ref2.state;
      return "entered" === e && "\n    opacity: 1;\n  ";
    }),
        p = l.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  top: 50px;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 60px;\n  margin: auto;\n  margin: ", ";\n  opacity: 0;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n\n  ", "\n\n  ", "\n\n  background-color: white;\n  color: ", ";\n\n  z-index: 10000;\n  transition: 0.3s;\n  animation: mounting 0.3s 1;\n  animation-timing-function: ease-out;\n\n  ", "\n\n  ", " {\n    max-width: ", ";\n    margin: auto;\n  }\n"])), function (_ref3) {
      var e = _ref3.mobileMargin;
      return Number.isInteger(e) ? "auto ".concat(e, "px") : e;
    }, function (_ref4) {
      var e = _ref4.roundedCorners;
      return e && "\n    border-radius: 4px;\n  ";
    }, function (_ref5) {
      var e = _ref5.fullMobile;
      return e && "\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n\n    ".concat(s.breakPoints.tablet, " {\n      height: auto;\n      margin: auto;\n    }\n  ");
    }, c.shadeDark, function (_ref6) {
      var e = _ref6.state;
      return "entered" === e && "\n    top: 0;\n    opacity: 1;\n  ";
    }, s.breakPoints.tablet, function (_ref7) {
      var e = _ref7.width;
      return Number.isInteger(e) ? e + "px" : e;
    }),
        m = l.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  display: none;\n  grid-template-columns: 1fr 40px;\n  justify-content: flex-start;\n  align-items: center;\n\n  width: 100%;\n  min-height: 60px;\n  background-color: ", ";\n  padding: 10px 20px;\n  box-sizing: border-box;\n\n  ", "\n"])), function (_ref8) {
      var e = _ref8.color;
      return e || c.newKinedu;
    }, function (_ref9) {
      var e = _ref9.show;
      return e && l.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: grid;\n  "])));
    }),
        g = l.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: white;\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: -0.5px;\n  line-height: 24.5px;\n\n  ", " {\n    font-size: 20px;\n  }\n\n  ", "\n"])), s.breakPoints.desktop, function (_ref10) {
      var e = _ref10.titleAlign;
      return "text-align: " + e;
    }),
        b = l.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n\n  display: flex;\n  justify-content: flex-end;\n  padding: 12px;\n"]))),
        h = l.default(u.default).attrs(function (_ref11) {
      var e = _ref11.color,
          _ref11$closeIconName = _ref11.closeIconName,
          t = _ref11$closeIconName === void 0 ? "close" : _ref11$closeIconName;
      return {
        name: t,
        color: e,
        size: 35
      };
    })(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  padding: 4px;\n  box-sizing: border-box;\n  cursor: pointer;\n  z-index: 1;\n"])));

    t.default = function (_ref12) {
      var e = _ref12.children,
          t = _ref12.className,
          o = _ref12.closeButtonColor,
          n = _ref12.closeIconName,
          r = _ref12.headerColor,
          _ref12$mobileMargin = _ref12.mobileMargin,
          l = _ref12$mobileMargin === void 0 ? 0 : _ref12$mobileMargin,
          _ref12$onClosedModal = _ref12.onClosedModal,
          s = _ref12$onClosedModal === void 0 ? function () {} : _ref12$onClosedModal,
          u = _ref12.openModal,
          x = _ref12.overlayColor,
          _ref12$roundedCorners = _ref12.roundedCorners,
          y = _ref12$roundedCorners === void 0 ? !0 : _ref12$roundedCorners,
          _ref12$showCloseButto = _ref12.showCloseButton,
          v = _ref12$showCloseButto === void 0 ? !0 : _ref12$showCloseButto,
          _ref12$closeOnBackdro = _ref12.closeOnBackdrop,
          w = _ref12$closeOnBackdro === void 0 ? !0 : _ref12$closeOnBackdro,
          M = _ref12.submitModal,
          _ = _ref12.title,
          _ref12$titleAlign = _ref12.titleAlign,
          k = _ref12$titleAlign === void 0 ? "left" : _ref12$titleAlign,
          _ref12$width = _ref12.width,
          P = _ref12$width === void 0 ? 620 : _ref12$width;

      var _i$useState = i.useState(!0),
          _i$useState2 = _slicedToArray(_i$useState, 2),
          $ = _i$useState2[0],
          C = _i$useState2[1],
          j = function j(e) {
        document.body.style.overflow = e;
      };

      i.useEffect(function () {
        var e = u ? "hidden" : "scroll";
        C(u), j(e);
      }, [u]);

      var O = function O() {
        C(!1), s(), j("");
      };

      return u ? i.default.createElement(d.default, {
        rootId: "modal-root"
      }, i.default.createElement(a.default, {
        in: $,
        timeout: 300,
        unmountOnExit: !0,
        appear: !0
      }, function (a) {
        return i.default.createElement(f, {
          "data-testid": "lego-modal-overlay",
          onClick: w ? function () {
            return O();
          } : function () {},
          state: a,
          overlayColor: x
        }, i.default.createElement(p, {
          "data-testid": "lego-modal-styled",
          roundedCorners: y,
          width: P,
          onClick: function onClick(e) {
            e.stopPropagation();
          },
          className: "modal " + t,
          state: a,
          mobileMargin: l
        }, i.default.createElement(m, {
          "data-testid": "lego-modal-header",
          className: "modal-header",
          show: !!_,
          color: r
        }, "function" == typeof _ ? _() : i.default.createElement(g, {
          "data-testid": "lego-modal-header-title",
          titleAlign: k
        }, _)), v && i.default.createElement(b, {
          "data-testid": "lego-modal-icon-wrapper",
          className: "modal-close-wrapper"
        }, i.default.createElement(h, {
          "data-testid": "lego-modal-close-button",
          className: "modal-close-icon",
          closeIconName: n,
          onClick: O,
          color: o || c.shadeMediumLight
        })), e({
          closeModal: O,
          submitModal: M,
          openModal: u
        })));
      })) : null;
    };
  },
  64: function _(e, t) {
    e.exports = require("react-transition-group/Transition");
  },
  8: function _(e, t) {
    e.exports = require("../Portal/Portal");
  }
});